<template>
  <div class="third">
    <component :is="labelName" :ref="labelName" @changeComponent="setComponent" :rowId="rowId"></component>
  </div>
</template>

<script>
import homePage from './main';
import importPub from "./secondPage/importPub";
import information from "./secondPage/information";
import myService from "./secondPage/myService";
import serviceScenariosAndAervices from "./secondPage/serviceScenariosAndAervices";
import thirdService from "./secondPage/thirdService";
import timetable from "./secondPage/timetable";
import backlog from "./secondPage/backlog";
import special from "./secondPage/special/special";
import specialDetail from "./secondPage/special/detail";
import { setStore, getStore } from "@/utils/store";

export default {
  name: 'userMan',
  data() {
    return {
      labelName: 'homePage',
      rowId: ''
    }
  },
  components: {
    backlog,
    timetable,
    specialDetail,
    special,
    homePage,
    importPub,
    information,
    myService,
    thirdService,
    serviceScenariosAndAervices
  },
  created() {
    const sessionData = getStore({
      name: 'serviceSettingComponent',
      type: 'session'
    })
    if(sessionData){
      const {
        val,
        rowId
      } = sessionData
      this.labelName = val || 'homePage'
      this.rowId = rowId || ''
    }
  },
  methods: {
    // 新增 编辑
    setComponent(val,rowId) {
      setStore({
        name: 'serviceSettingComponent',
        content: {
          val: val || '',
          rowId: rowId || ''
        },
        type:'session'
      })
      this.labelName = val || 'homePage'
      this.rowId = rowId || ''
    },
  },
  destroyed() {
      setStore({
        name: 'serviceSettingComponent',
        content: {
          val: '',
          rowId: ''
        },
        type:'session'
      })
  },
}
</script>
